import { render, staticRenderFns } from "./setPrice.vue?vue&type=template&id=d818bbc8&scoped=true"
import script from "./setPrice.vue?vue&type=script&lang=js"
export * from "./setPrice.vue?vue&type=script&lang=js"
import style0 from "./setPrice.vue?vue&type=style&index=0&id=d818bbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d818bbc8",
  null
  
)

export default component.exports